/* eslint-disable */
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

type ClickLinkProps = {
  link: string;
  text: string;
  extenalLink?: boolean;
};

const ClickLink: React.FC<ClickLinkProps> = ({
  link,
  text,
  extenalLink = false,
}) => {
  const history = useHistory();

  const handleExecute = useCallback(() => {
    history.push(`/${link}`);
  }, [history, link]);

  return extenalLink ? (
    <a href={link} target="_blank">{text}</a>
  ) : (
    <button type="button" onClick={handleExecute}>
      {text}
    </button>
  );
};

export default ClickLink;
